"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = (e) => {
    var _a;
    const text = e.label;
    if (!text)
        return;
    if (typeof window.ctConstants === 'undefined')
        return;
    const analyticsEvent = {};
    window.digitalData.component = [];
    window.digitalData.component.push({
        componentInfo: {
            componentID: '',
            componentName: e.component || 'NO COMPONENT NAME',
        },
        attributes: {
            position: e.total || '',
            variants: e.variants || '',
            DTResult: e.dtResult || '',
            DTMSARes: e.dtResultAns || '',
            quizInfo: ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.quizInfo) || '', //'<Quiz type> - <variant>' Hair anaylasis - take selie/skip | Skin anaylasis - take selie |take quiz?
        },
    });
    window.digitalData.component[0].attributes.subattributes = [...e.data];
    analyticsEvent.eventInfo = {
        type: window.ctConstants.diagtooleve,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.engagement,
    };
    analyticsEvent.subcategory = 'Interest';
    analyticsEvent.action = window.ctConstants.DiagnosticToolResults;
    analyticsEvent.label = `${text}`;
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
